import { createContext, useContext, useState, useEffect } from "react";
import { GetUserByUserName } from "../services/UserService";

const LanguageContext = createContext({ lang: "fa", setLang: () => {} });

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(localStorage.getItem("language") || "fa");

    const setLang = (newLang) => {
        setLangState(newLang);
        localStorage.setItem("language", newLang);
    };

    useEffect(() => {
        const userName = localStorage.getItem("userName");
        const token = localStorage.getItem("token");
        if (!userName || !token) return;
        GetUserByUserName(userName)
            .then(({ data }) => {
                console.log("User data from DB:", data);
                if (data?.language) {
                    setLang(data.language);
                }
            })
            .catch((err) => {
                console.error("Error fetching language:", err);
            });
    }, []);

    return (
        <LanguageContext.Provider value={{ lang, setLang }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext);
}